/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


  $('.product_images_slider').slick({
     dots: true,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0825/1470/6730/files/back_1.png?v=1702272668' width=20px>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0825/1470/6730/files/next_1.png?v=1702272668'  width=20px>"
  });
  if ($(window).width() < 768) {
  $('#complementary-products .grid-layout').slick({
      slidesToShow: 1,
    dots:false,
    arrows:false,
  });
    }